/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'local': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M117.602 105.801h-84a4.694 4.694 0 0 1-4.7-4.7h93.5c-.003 2.5-2.202 4.7-4.8 4.7z" _fill="#C4FFF9" fill-rule="nonzero"/><path pid="1" d="M115.102 96.5h-79c-.398 0-.8-.3-.8-.8V50.3c0-2.101 1.698-3.8 3.8-3.8h73c2.102 0 3.8 1.699 3.8 3.8v45.5c-.003.399-.402.7-.8.7V96.5z" _stroke="#C4FFF9" stroke-width="6"/></g>'
  }
})
